import LSChannel from './live-streaming-channel.js';
import LSCategory from './live-streaming-category.js';
import LSSettings from './live-streaming-setting.js';
import LSIntegrationStreamit from './live-streaming-integration.js';
import Live_Streaming_Api_Admin from './live-streaming-api-admin.js';
import LSEPG from './live-streaming-epg.js';
import './flatpickr.js';
import './../css/live-streaming-admin.css';

jQuery(document).ready(function ($) {

    // Initialize custom modules
    const DashboardSideBarModule = {
        ls_channel: new LSChannel(),
        ls_category: new LSCategory(),
        ls_settings: new LSSettings(),
        ls_streamit_integration: new LSIntegrationStreamit(),
        ls_epg: new LSEPG(),
        ls_api_admin: new Live_Streaming_Api_Admin()
    };

    window['DashboardSideBarModule'] = DashboardSideBarModule;


    // Initialize Flatpickr for date fields
    if (typeof flatpickr !== 'undefined') {
        $('.ls_flatpickr').each(function () {
            const $input = $(this);
            const disablePastDates = $input.data('disable-past') === 1;

            flatpickr(this, {
                dateFormat: 'Y-m-d',
                minDate: disablePastDates ? 'today' : null
            });
        });
    }

    $('.ls_select2').select2({
        width: '100%'
    });
});
